(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/youtube-video/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/components/youtube-video/assets/javascripts/init.js');

'use strict';

var logger = svs.core.log.getLogger('component:youtube-video_init');


function youtubeIframe(el, src, id) {
  var iframe = document.createElement('iframe');
  iframe.setAttribute('class', "js-youtube-video-".concat(id, " js-youtube-video-iframe youtube-video-iframe"));
  iframe.setAttribute('src', "".concat(src, "&autoplay=1"));
  iframe.setAttribute('allowfullscreen', '1');
  iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
  el.style.display = 'none';
  el.closest('div.js-youtube-video-container').append(iframe, el);
}
svs.components.youtube_video.init = function (options) {
  if (!options.videoId) {
    logger.error('Missing videoId');
    return;
  }
  if (options && options.selector && options.src) {
    var videoHtml = svs.components.youtube_video.templates.youtube_video(options);
    $(options.selector).append(videoHtml);
  } else {
    logger.error('Error in options object', options);
  }
};
svs.components.youtube_video.renderYoutubePlayer = function (event, videoSrc, videoId) {
  var element = event.target;
  youtubeIframe(element, videoSrc, videoId);
};
document.addEventListener('DOMContentLoaded', function () {
  var imageElements = document.querySelectorAll('.js-youtube-video-thumbnail');
  imageElements.forEach(function (element) {
    if (element.naturalWidth === 120 && element.naturalHeight === 90) {
      var fallbackImage = element.cloneNode(true);
      element.parentElement.style.display = 'none';
      element.parentElement.parentElement.prepend(fallbackImage);
    }
  });
});
function setFocusOnTab() {
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      var focusOutline = document.querySelector('.focus-outline');
      if (focusOutline) {
        focusOutline.classList.remove('focus-outline');
      }
      setTimeout(function () {
        var activeElement = document.activeElement;
        if (activeElement && activeElement.classList.contains('js-youtube-video-iframe')) {
          var parentVideoContainer = activeElement.parentElement.closest('.js-youtube-video-container');
          if (parentVideoContainer) {
            parentVideoContainer.classList.add('focus-outline');
          }
        }
      }, 50);
    }
  });
  document.addEventListener('keyup', function () {
    var focusOutline = document.querySelector('.focus-outline');
    if (focusOutline) {
      focusOutline.classList.remove('focus-outline');
    }
  });
  document.addEventListener('mousedown', function () {
    var focusOutline = document.querySelector('.focus-outline');
    if (focusOutline) {
      focusOutline.classList.remove('focus-outline');
    }
  });
  document.addEventListener('blur', function () {
    var focusOutline = document.querySelector('.focus-outline');
    if (focusOutline) {
      focusOutline.classList.remove('focus-outline');
    }
  });
}
if (svs.core.detect.formfactor.desktop()) {
  setFocusOnTab();
}

 })(window);